import { InlineExpander, Alert } from '@amzn/storm-ui'
import styled, { css } from 'styled-components'
import { isMobileStyleMixin as isMobile, Text, TextButton } from '@amzn/storm-ui'
import { AapnLink } from '../../shared/components/aapn_routing/aapn_routing'
import { APP_MAX_WIDTH } from '../../shared/components/shared_components.styles'
import { A20MTopMarginValue, A20MTopPaddingValue } from '../../App.styles'

export type ComparisonDetailsWrapperProps = {
  partnerComparisonHeroImg: string
}

export const PartnerComparisonDetailsWrapper = styled.div<ComparisonDetailsWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-block-start: ${`${A20MTopMarginValue}px`};
  background-image: url('${({ partnerComparisonHeroImg }) => partnerComparisonHeroImg}');
  background-size: contain;
  background-position-y: -1.25%;
  background-repeat: no-repeat;
  .hidden-partner-compare-sticky-header {
    &#partner-comparison-sticky-header {
      display: none;
    }
  }
  .displayed-partner-compare-sticky-header {
    &#partner-comparison-sticky-header {
      display: flex;
    }
  }
`

export const PartnerComparisonContentWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  max-width: ${APP_MAX_WIDTH};
`

export const CommonWidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: ${APP_MAX_WIDTH};
`

export const StickyMicroCardsContainer = styled.div`
  display: flex;
  width: 90%;
  max-width: ${APP_MAX_WIDTH};
`

export const StickyMicroPartnerCardContainer = styled.div`
  display: flex;
  flex: 1;
  flex-basis: 0;
  min-width: 0;
  margin: ${({ theme }) => theme.spacing.medium};
`

export const InvisibleContainer = styled.div`
  display: flex;
  flex-basis: 0;
  width: 90%;
  flex-grow: 1;
  margin: ${({ theme }) => theme.spacing.medium};
`

export const StyledInlineExpander = styled(InlineExpander)`
  align-items: center;
  width: 100%;
  :hover {
    text-decoration: none;
  }
`

export const RecognitionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`
export const RecognitionImage = styled.img`
  display: flex;
  max-height: 100px;
  max-width: 220px;
  justify-content: flex-start;
  object-fit: contain;
`

export const MobileComparisonDetailsWrapper = styled.div<ComparisonDetailsWrapperProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('${({ partnerComparisonHeroImg }) => partnerComparisonHeroImg}');
  background-size: contain;
  background-repeat: no-repeat;
  .slick-prev::before,
  .slick-next::before {
    color: ${({ theme }) => theme.palette.black};
    font-style: normal;
  }
  .slick-prev,
  .slick-next {
    z-index: 1;
  }
  .slick-prev {
    left: 5%;
  }
  .slick-next {
    right: 5%;
  }
`

export const PageTitleText = styled(Text)`
  ${isMobile(css`
    margin-bottom: ${({ theme }) => theme.spacing.large};
  `)}
`

export const LinkContainerWrapper = styled.div`
  ${isMobile(css`
    font-size: ${({ theme }) => theme.typography.size.base};
  `)}
`

export const LinkContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.large};
  font-size: ${({ theme }) => theme.typography.size.base};
`

export const MobileLinkContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.small};
  margin-top: ${({ theme }) => theme.spacing.base};
`
export const CompareCardsContainer = styled.div`
  display: flex;
  flex-grow: 3;
  flex-basis: 0;
  ${isMobile(css`
    flex-direction: column;
  `)}
`

export const LegendsAndCardsContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.xlarge};
`

export const DashFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(to right, ${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) top repeat-x,
    linear-gradient(${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) right repeat-y,
    linear-gradient(to right, ${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) bottom repeat-x,
    linear-gradient(${({ theme }) => theme.palette.dustyGray} 50%, transparent 0%) left repeat-y;
  background-size: 10px 2px, 2px 10px;
`

export const StyledAapnLink = styled(AapnLink)`
  flex-grow: 1;
`

export const SliderWrapper = styled.div`
  position: sticky;
  top: ${A20MTopPaddingValue}px;
  width: 100%;
  height: 200px;
  margin-bottom: ${({ theme }) => theme.spacing.base};
  background-color: ${({ theme }) => theme.palette.white};
  .slick-dots li button:before {
    font-size: ${({ theme }) => theme.typography.size.base};
  }
  z-index: 1;
  padding-bottom: ${({ theme }) => theme.spacing.xxlarge};
  border-top: 1px solid ${({ theme }) => theme.palette.alto};
  border-bottom: 1px solid ${({ theme }) => theme.palette.alto};
`

export const SliderItemWrapper = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 30px;
`
export const ScrollToTopButton = styled(TextButton)`
  margin-top: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const SliderDashFrame = styled(DashFrame)`
  width: 100px;
  height: 100px;
`

export const GrayAapnLink = styled(AapnLink)`
  color: ${({ theme }) => theme.palette.emperor} !important;
`

export const SliderText = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing.medium} !important;
  padding-bottom: ${({ theme }) => theme.spacing.xxlarge};
`

export const PrevIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 5%;
  cursor: pointer;
  z-index: 2;
`

export const NextIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 5%;
  cursor: pointer;
  z-index: 2;
`

export const StickyCtaLink = styled(AapnLink)`
  display: flex;
  flex: 1;
  flex-basis: 0;
  min-width: 0;
  margin: ${({ theme }) => theme.spacing.medium};
`

export const StickyComparisonHeader = styled.div`
  justify-content: center;
  position: sticky;
  top: ${A20MTopPaddingValue}px;
  width: 100%;
  height: 105px;
  -webkit-box-shadow: 0 4px 6px -6px ${({ theme }) => theme.palette.iris[900]};
  -moz-box-shadow: 0 4px 6px -6px ${({ theme }) => theme.palette.iris[900]};
  box-shadow: 0 4px 6px -6px ${({ theme }) => theme.palette.iris[900]};
  background-color: ${({ theme }) => theme.palette.white};
  z-index: 1;
`

export const UnsupportedAlert = styled(Alert)`
  margin-top: ${({ theme }) => theme.spacing.base};
  ${isMobile(css`
    margin-top: 0;
  `)}
`
